document.addEventListener("DOMContentLoaded", function () {
  const cartIcon = document.getElementById("cartIcon");
  const popup = document.getElementById("cartPopup");

  // Add to Cart Button Click
  document.querySelectorAll(".open-cart-popup").forEach(button => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");
      const cartIconImg = this.querySelector("img");

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(response => response.json())
        .then(data => {
          // Change icon to tick
          if (cartIconImg) {
            cartIconImg.src = "{{ 'checkmark_icon.png' | asset_url }}";
          }

          // Update header cart
          updateHeaderCart();

          // Show popup
          if (popup) {
            popup.classList.remove("hide");
            popup.classList.add("show");

            // Auto-hide popup after 4s
            setTimeout(() => {
              popup.classList.add("hide");
              setTimeout(() => {
                popup.classList.remove("show", "hide");
              }, 400);
            }, 4000);
          }
        })
        .catch(error => {
          console.error("Cart add error:", error);
          alert("Failed to add product. Try again.");
        });
    });
  });

  // Close popup
  const closeBtn = document.querySelector(".cart-popup-close");
  if (closeBtn && popup) {
    closeBtn.addEventListener("click", () => {
      popup.classList.add("hide");
      setTimeout(() => {
        popup.classList.remove("show", "hide");
      }, 400);
    });
  }

  // Cart icon click → show popup instead of redirect
  if (cartIcon && popup) {
    cartIcon.addEventListener("click", (e) => {
      e.preventDefault(); // prevent default navigation

      popup.classList.remove("hide");
      popup.classList.add("show");
      updateHeaderCart();

      setTimeout(() => {
        popup.classList.add("hide");
        setTimeout(() => {
          popup.classList.remove("show", "hide");
        }, 1400);
      }, 30000);
    });
  }

  // Update cart content
  function updateHeaderCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartCountEl = document.getElementById("cartCount");
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
        }

        if (!popup) return;

        if (cart.items.length === 0) {
          popup.innerHTML = "<p>Your cart is empty.</p>";
          return;
        }

        let html = `
          <div class="cart-popup-header">
            <span class="cart-popup-icon">✔</span>
            <span class="cart-popup-title">Added to cart</span>
            <button class="cart-popup-close" aria-label="Close">&times;</button>
          </div>
          <div class="cart-items-scroll">`;

        cart.items.forEach(item => {
          const productType = item.product_type || '';
          const frame = item.properties && item.properties['Frame'] ? item.properties['Frame'] : '';

          html += `
            <div class="cart-item-container-main">
              <div class="cart-item-container">
                <div class="cart-item-content">
                  <div class="cart-item">
                    <img src="${item.image}" width="50" height="50" />
                    <div class="cart-item-details">
                      <p class="cart-item-title">${item.product_title}</p>
                      ${productType ? `<p class="cart-item-type">${productType}</p>` : ''}
                      ${frame ? `<p class="cart-item-frame">Frame: ${frame}</p>` : ''}
                      <p class="cart-item-qty">Qty: ${item.quantity}</p>
                      <p class="cart-item-price">$${(item.line_price / 100).toFixed(2)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>`;
        });

        html += `</div>`; // close .cart-items-scroll

        html += `
          <div class="cart-subtotal" style="display:none;"><strong>Subtotal:</strong> $${(cart.total_price / 100).toFixed(2)}</div>
          <div class="cart-popup-actionsss">
            <a href="/cart" class="button">View cart</a>
            <a href="/checkout" class="button primary">Checkout</a>
          </div>`;

        popup.innerHTML = html;

        // Re-bind close button inside dynamic content
        const newCloseBtn = popup.querySelector(".cart-popup-close");
        if (newCloseBtn) {
          newCloseBtn.addEventListener("click", () => {
            popup.classList.add("hide");
            setTimeout(() => {
              popup.classList.remove("show", "hide");
            }, 400);
          });
        }
      });
  }
});